import { render, staticRenderFns } from "./UserStakingStats.vue?vue&type=template&id=dcff7de0&scoped=true&"
import script from "./UserStakingStats.vue?vue&type=script&lang=js&"
export * from "./UserStakingStats.vue?vue&type=script&lang=js&"
import style0 from "./UserStakingStats.vue?vue&type=style&index=0&id=dcff7de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcff7de0",
  null
  
)

export default component.exports